import { VehiclesInvalidRecord } from './vehicles-invalid-record';

export class VehiclesImportResponse {
  constructor(
    public imported = 0,
    public importInserted = 0,
    public importUpdated = 0,
    public invalid: VehiclesInvalidRecord[] = [],
    public unrecoverable = 0,
    public importComplete = false
  ) {}
}
